export default function getCookiePolicy(website) {
  return website?.documents?.find((doc) => doc.name.includes('Cookie'))
}
